import { useEffect } from 'react';
import { isLiveStream } from '@core/livestream/helpers';
import { useStore } from '@core/widgets/store';
import { useEmbedFeedStore } from '../embedFeed/store';
import { ENGAGEMENT_INTERACTABLE_VIEW_V2 } from './endpoints/engagement';
import { useTrackEmbedEngagedVideo } from './useTrackEmbedEngagedVideo';
/**
 * Tracks when a user has engaged with a video in the embed feed.
 */
export function useTrackEmbedInteractableEngagedVideo({ appContext, }) {
    const engagedVideoId = useStore((store) => store.engagedVideoId);
    const engagedVideoIdV2 = useStore((store) => store.engagedVideoIdV2);
    const autoPlayId = useEmbedFeedStore((state) => state.autoplayId);
    const videos = useStore((state) => state.videos);
    const engagedVideo = Object.values(videos).find((video) => video.encoded_id === engagedVideoId);
    const isVideoALivestream = isLiveStream(engagedVideo || null);
    const trackEmbedEngagedVideo = useTrackEmbedEngagedVideo();
    useEffect(() => {
        if (engagedVideoId &&
            autoPlayId === engagedVideoId &&
            !isVideoALivestream) {
            trackEmbedEngagedVideo(appContext, engagedVideoId);
        }
    }, [
        engagedVideoId,
        trackEmbedEngagedVideo,
        appContext,
        autoPlayId,
        isVideoALivestream,
    ]);
    useEffect(() => {
        if (engagedVideoIdV2 &&
            autoPlayId === engagedVideoIdV2 &&
            !isVideoALivestream) {
            trackEmbedEngagedVideo(appContext, engagedVideoIdV2, ENGAGEMENT_INTERACTABLE_VIEW_V2);
        }
    }, [
        engagedVideoIdV2,
        trackEmbedEngagedVideo,
        appContext,
        autoPlayId,
        isVideoALivestream,
    ]);
}
